<template>
  <section>
    <b-modal :active.sync="isComponentEditActive" has-modal-card :can-cancel="false">
      <div class="modal-card">
          <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
        <header class="modal-card-head">
          <p class="modal-card-title">Editar Perfil</p>
        </header>
        <section class="modal-card-body">
          <b-field label="Nombre">
            <b-input
              type="text"
              :value="user.name"
              v-model="user.name"
              placeholder="Nombre"
              required
            ></b-input>
          </b-field>
          <b-field label="Apellido Paterno">
            <b-input
              type="text"
              :value="user.pather_lastname"
              v-model="user.pather_lastname"
              placeholder="Apellido Paterno"
              required
            ></b-input>
          </b-field>
          <b-field label="Apellido Materno">
            <b-input
              type="text"
              :value="user.mother_lastname"
              v-model="user.mother_lastname"
              placeholder="Apellido Materno"
              required
            ></b-input>
          </b-field>
          <b-field label="Rut">
            <b-input type="text" :value="user.rut" v-model="user.rut" placeholder="RUT" required></b-input>
          </b-field>
          <b-field label="Email">
            <b-input
              type="email"
              :value="user.email"
              v-model="user.email"
              placeholder="Your email"
              required
            ></b-input>
          </b-field>
         
         
       
        
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="closeEdit()">Cerrar</button>
          <button class="button is-primary" @click="editUser()">Editar</button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>
<script>
import { UserService } from '../services/models/user';
export default {
  props: ["isComponentEditActive", "closeEdit", "user_id", "nameUserConnect"],
  data() {
    return {
      user: {
        name: "",
        pather_lastname: "",
        mother_lastname: "",
        rut: "",
        email: "",
        password: ""
      },
      
      isLoading:true
    };
  },
  created: function() {
     this.chargeUserData().then(()=>{
          this.isLoading=false;
        });
  },
  methods: {
    
    editUser: function() {
      this.isLoading=true;
      let data = {
        ...this.user
      };
     UserService.update(this.user_id, data).then(
        response => {
          //Limpia el objeto User
          for (const i in this.user) {
            this.user[i] = "";
          }
          console.log("PUT:", response.data);
          window.localStorage.setItem("user",JSON.stringify(response.data.user));
          window.localStorage.setItem("userName",
          `${response.data.user.name} ${response.data.user.pather_lastname} ${response.data.user.mother_lastname}`
          );
          this.closeEdit();
          this.nameUserConnect();
          this.toast("El usuario ha sido editado correctamente", "is-success");
          this.isLoading=false;
        },
        response => {
          this.toast("error al editar", "is-danger");
          this.isLoading=false;
          console.log("error: ", response);
        }
      );
    },
    
    chargeUserData: async function() {
      const {data : user} = await UserService.getById(this.user_id);
      this.user = user[0];
    }
  }
};
</script>